<template>
  <div @click="clickedRowAction(trItem['.key'])">
    <div :key="item.id" v-for="item in gridItemConfig">
      {{trItem[item.string]}}
      {{item.key}}
      {{item.string}}
      <div v-html="item.html" :style="item.style"></div>
      <div :trItem="trItem"  :is="item.componentName"></div>
    </div>
  </div>
</template>

<script>
import { ref } from "@/components/puntatori";
import { EventBus } from "../main.js";
import Vue from "vue";

//i pulsanti azioni devono essere un componente a se stante
//header componente ??
//riga componente ? in futuro magari ?
export default {
  name: "crudTableGridItem",
  directives: {},
  props: ["trItem", "gridItemConfig"],
  data() {
    return {

    };
  },
  computed: {},
  methods: {
    clickedRowAction(key) {
      if (key !== undefined) {
        this.$router.push(this.$route.path + "?id=" + key);
        EventBus.$emit("stato_tendina", true);
			}
			else console.log(this.$options.name +'-'+ 'key non definita')
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style scoped>
main .table-striped tbody tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

main .table-striped tbody tr {
  background-color: white;
	cursor: pointer;
}

main .table-striped tbody tr:hover {
  background-color: #f5f5f5;
}
</style>
